import { Route, Routes } from "react-router-dom";

import UsersPage from "./pages/UsersPage";

export const UsersNavigation = () => {
  return (
    <Routes>
      <Route index element={<UsersPage />} />
    </Routes>
  );
};
